// Component: src/theme/snippets/text-block.liquid

document.querySelectorAll(".text-block").forEach(($el) => {
  const readButton = $el.querySelector(".text-block-read-button");
  readButton?.addEventListener("click", () => {
    $el.classList.toggle("is-active");
  });
});
